// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__3QG2F","active":"downloadDropdown_active__G_WO_"};